import React from "react";

import { SearchResultsProvider } from "./data/useSearchResults";
import { FiltersProvider } from "./data/useFilters";
import { ConfigProvider } from "./data/useConfig";

import "./App.less";
import LayoutApp from "./Layout";

const AppSearch = () => {
  return (
    <ConfigProvider>
      <SearchResultsProvider>
        <FiltersProvider>
          <LayoutApp onlyInput={true} />
        </FiltersProvider>
      </SearchResultsProvider>
    </ConfigProvider>
  );
};

export default AppSearch;
